import get from 'lodash/get';

import { getDispensingSitesRequest } from '../../api/requests';
import { logoutHandle } from '../user/actions';

export const GET_SETTINGS_SITES = 'GET_SETTINGS_SITES';

export const getSettingsSites = () => async dispatch => {
  try {
    const response = await getDispensingSitesRequest();
    dispatch(({ type: GET_SETTINGS_SITES, payload: { dispensingSites: get(response, 'data') } }));
    return response;
  } catch (e) {
    if ([401, 422].includes(get(e, 'response.status'))) {
      logoutHandle(dispatch);
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions.js